import { VENDOR_IDS } from '../../../constants/vendor';

export const customWording = {
  [VENDOR_IDS.AG1]: {
    'Your Scale is Ready to Go!': 'Your Canister is Ready to Go!',
    'Scale successfully linked.': 'Smart canister successfully linked.',
  },
};
